(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fbj-shop-nav"] && !Shopify.designMode) return;
  try {
    
  const setFbjShopNavActive = (links, activeId) => {
    links.forEach((link) => {
      if (link.dataset.anchorId === activeId) {
        link.setAttribute('aria-current', 'location');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  };

  const initializeFbjShopNav = (nav) => {
    if (nav.dataset.fbjShopNavReady === 'true') return;

    const links = Array.from(nav.querySelectorAll('[data-fbj-shop-nav-link]'));
    const targets = links
      .map((link) => document.getElementById(link.dataset.anchorId))
      .filter(Boolean);

    if (links.length === 0 || targets.length === 0) return;

    nav.dataset.fbjShopNavReady = 'true';
    let animationFrame = null;

    const updateFromScroll = () => {
      animationFrame = null;
      const activationLine = nav.getBoundingClientRect().bottom + 24;
      let activeId = targets[0].id;

      targets.forEach((target) => {
        if (target.getBoundingClientRect().top <= activationLine) {
          activeId = target.id;
        }
      });

      setFbjShopNavActive(links, activeId);
    };

    const queueScrollUpdate = () => {
      if (animationFrame !== null) return;
      animationFrame = window.requestAnimationFrame(updateFromScroll);
    };

    const handleClick = (event) => {
      const link = event.target.closest('[data-fbj-shop-nav-link]');
      if (!link || !nav.contains(link)) return;
      setFbjShopNavActive(links, link.dataset.anchorId);
    };

    nav.addEventListener('click', handleClick);
    window.addEventListener('scroll', queueScrollUpdate, { passive: true });
    window.addEventListener('resize', queueScrollUpdate);

    const hashId = decodeURIComponent(window.location.hash.slice(1));
    if (links.some((link) => link.dataset.anchorId === hashId)) {
      setFbjShopNavActive(links, hashId);
    } else {
      updateFromScroll();
    }
  };

  document.querySelectorAll('[data-fbj-shop-nav]').forEach(initializeFbjShopNav);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-fbj-shop-nav]').forEach(initializeFbjShopNav);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
